<template>
  <div class="profit-page">
    <div class="profit-title" id="page-top">
      <div class="profit-title-left">
        <span>{{ timestamp }}</span>
      </div>
      <div class="profit-title-right">
        <a-button icon="printer" type="primary border-arc" @click="btnPrint">打印</a-button>
      </div>
    </div>
    <div class="profit-table" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataSource" :expandedRowKeys="expandedRowKeys" :pagination="false"
        :scroll="{ y: (tableHeight) }" bordered rowKey="id">
        <template slot="name" slot-scope="text, record">
          {{ record.name }}
        </template>
        <template slot="icon" slot-scope="text, record">
          {{ record.meta.icon }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <span style="color:#387BFC;cursor: pointer;" v-if="record.detailedFlag==1" @click="btnLookDetails(record)">明细</span>
        </template>
      </a-table>
    </div>
    <date-modal ref="selectdate"></date-modal>
    <preview-print ref="printPreview"></preview-print>
  </div>
</template>
<script>
import { getSellReportList } from "@/utils/api";
import dateModal from "./dateModal.vue";
import previewPrint from '@/components/print/previewPrint.vue'
export default {
  name: "profit",
  components: {
    dateModal,
    previewPrint
  },
  data() {
    return {
      timestamp:null,
      columns: [
        {
          title: "项目",
          dataIndex: "name",
        },
        {
          title: "金额",
          align: "right",
          dataIndex: "totalAmount",
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],
      dataSource: [],
      urlList: {
        list: "/finance/api/financeIncomeStatement/listFinanceIncomeStatement",
      },
      tableHeight: null,
      contentHeight: null,
      expandedRowKeys: [],
    };
  },
  activated() {
    let _that = this
    setTimeout(function() {
      let tdHeight = document.getElementsByTagName('tr')[0].offsetHeight
      let header = document.getElementById("header").offsetHeight;
      let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
      let pageHeight = document.getElementById('content').offsetHeight
      let makeTop = document.getElementById('page-top').offsetHeight
      _that.contentHeight = pageHeight - makeTop - header - tdHeight * 0.32
      _that.tableHeight = _that.contentHeight - tdHeight
    }, 50)
    this.getProfitListOne();
  },
  methods: {
    // 打印弹框
    btnPrint() {
      let templateType = 506
      this.$refs.printPreview.open({
        templateType: templateType
      })
    },
    getProfitListOne(level) {
      let params = {};
      let data = {
        companyStoreId: this.$store.state.userInfo.companyStoreId,
      };
      this.expandedRowKeys = [];
      getSellReportList(this.urlList.list, params, {}, data).then((res) => {
        if (res.code == 200) {
          res.result.map((one, onenum) => {
            one.children = one.sonFinanceIncomeStatementVOList;
            this.expandedRowKeys.push(one.id);
            if (one.sonFinanceIncomeStatementVOList.length > 0) {
              one.sonFinanceIncomeStatementVOList.map((two, twonum) => {
                two.children = two.sonFinanceIncomeStatementVOList;
                this.expandedRowKeys.push(two.id);
                if (two.sonFinanceIncomeStatementVOList.length > 0) {
                  two.sonFinanceIncomeStatementVOList.map((three, threenum) => {
                    three.children = three.sonFinanceIncomeStatementVOList;
                    this.expandedRowKeys.push(three.id);
                  });
                }
              });
            }
          });
          this.timestamp = res.timestamp
          this.dataSource = res.result;
          this.$store.state.isLoding = false;
        } else {
          this.$message.error(res.logMessage)
        }
      });
    },
    // 查看明细
    btnLookDetails(record) {
      this.$refs.selectdate.open(record);
    },
  },
};
</script>
<style lang="scss">
.profit-page {
  .profit-title {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    padding: 0 32px;
    .anticon-printer {
      color: #ffffff;
      font-size: 16px;
    }
  }
  .profit-table {
    height: calc(100vh - 260px);
    background-color: #ffffff;
    margin-top: 16px;
  }
  .ant-table-body {
    .ant-table-row {
      background: #ffffff !important;
    }
    .ant-table-row-level-0 {
      font-weight: bold;
    }
    .ant-table-row-level-1 {
      font-weight: bold;
      background: #f6f9fe !important;
    }
  }
  .ant-table-row-expand-icon {
    opacity: 0;
  }
}
</style>